import React from "react";
import {Divider} from "antd";


const Seperator = ({ style }) => {
  return (
    <Divider style={{...DEFAULT_STYLE, ...style}} />
  );
};


const DEFAULT_STYLE = {
  margin: '5px -10px',
};


export default Seperator;
